export enum GeneralAction {
  Init = 'general.init',
  RouteUpdate = 'general.routeUpdate',
  HandleSearchResponse = 'general.handleSearchResponse',
  HandleCategoriesSearchResponse = 'general.handleCategoriesSearchResponse',
  HandleExternalSearchResponse = 'general.handleExternalSearchResponse',
  HandleProductSearchResponse = 'general.handleProductSearchResponse',
  UpdateSearchResults = 'general.updateSearchResults',
  SwitchSearchTerm = 'general.switchSearchTerm',
  SwitchSearchContext = 'general.switchSearchContext',
  SwitchFilters = 'general.switchFilters',
}

export enum BaseAction {
  SwitchActiveLayout = 'base.switchActiveLayout',
  ChangeActiveRequests = 'base.changeActiveRequests',
  AddError = 'base.addError',
  AddWarning = 'base.addWarning',
  ClearErrors = 'base.clearErrors',
  ClearWarnings = 'base.clearWarnings',
}

export enum FilterAction {
  SetSideBarVisibility = 'filter.setSideBarVisibility',
  SwitchSearchContext = 'filter.switchSearchContext',
  ToggleFilterOption = 'filter.toggleFilterOption',
  RemoveAllAppliedFilterOptions = 'filter.removeAllAppliedFilterOptions',
  ToggleShowMore = 'filter.toggleShowMore',
  ToggleAccordion = 'filter.toggleAccordion',
}

export enum LocalizationAction {
  ChangeLocale = 'localization.changeLocale',
}

export enum SearchAction {
  LoadMore = 'search.loadMore',
  SearchWithNewTerm = 'search.searchWithNewTerm',
  SetStrictSearch = 'search.setStrictSearch',
  DoSearch = 'search.doSearch',
  DoListSearch = 'search.doListSearch',
  SetViewed = 'search.setViewed',
  DoSearchByType = 'search.doSearchByType',
  CategoriesLoadMore = 'search.categoriesLoadMore',
  ExternalLoadMore = 'search.externalLoadMore',
  ProductLoadMore = 'search.productLoadMore',
  ListLoadMore = 'search.listLoadMore',
}
